import {ErrorStateScheduleEnum} from '../error-state-schedule.enum';

export enum PanelSettingsOperatorsEditResolverErrorStatesEnum {
    GetOperatorFailed = ErrorStateScheduleEnum.PanelSettingsOperatorsEditResolverStatesStartIndex,
    OperatorNotFound,
    GetUserRolesFailed,
    UserRolesNotFound,
    GetRolesFailed,
    RolesNotFound,
    GetStatusTriggersFailed
}
